import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { SupplierContact } from './../Models/supplierContact';
import { SupplierList } from './../Models/supplierList';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SupplierServices {
  constructor(private http: HttpClient) {}

  createAuthorizationHeader(headers: Headers) {
    headers.append('content-type', 'application/json');
  }

  getAll() {
    return this.http
      .get<any>(
        `${environment.BASE_URL}/supplierlist/${BaseServices.BusinessId}`
      ).pipe(rxjsmap(result => result));
  }

  getActiveSuppliers() {
    return this.http
      .get<any>(
        `${environment.BASE_URL}/supplierdropdown/${BaseServices.BusinessId}`
      ).pipe(rxjsmap(result => result));
  }

  add(supplier: SupplierList) {
    return this.http
      .post(environment.BASE_URL + '/supplier', supplier).pipe(rxjsmap(result => result));
  }

  getById(id: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/suppliers/' + id).pipe(rxjsmap(result => (result ? result : null)));
  }

  update(supplier: SupplierList) {
    return this.http
      .put(environment.BASE_URL + '/supplier', supplier).pipe(rxjsmap(result => result));
  }

  addSupplierContact(suppliercontact: SupplierContact) {
    return this.http
      .post(
        environment.BASE_URL + '/suppliercontact/suppliercontact',
        suppliercontact
      ).pipe(rxjsmap(result => result));
  }

  deleteSuppliers(ids: number[]) {
    return this.http
      .put(environment.BASE_URL + '/supplier/', ids).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
  }

  getSupplierContactById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/suppliercontact/suppliercontacts/' + id).pipe(rxjsmap(result => result));
  }

  getSupplierContactListById(supplierId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL +
          '/suppliercontact/supplierscontact-list/' +
          supplierId
      ).pipe(rxjsmap(result => result));
  }

  getCountryCode() {
    return this.http
      .get(environment.BASE_URL + '/countrycode/countrycodes').pipe(rxjsmap((result: any) => result));
  }

  updateSupplierContact(suppliercontact: SupplierContact) {
    return this.http
      .put(
        environment.BASE_URL + '/suppliercontact/suppliercontact',
        suppliercontact
      ).pipe(rxjsmap(result => result));
  }

  getContactType() {
    return this.http
      .get<any>(environment.BASE_URL + '/contacttypes/contactTypes').pipe(rxjsmap(result => result));
  }

  deleteSupplierContact(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/suppliercontact/suppliercontact/' + id).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
  }

  statusUpdate(id: any, status: any) {
    return this.http
      .put(environment.BASE_URL + '/supplierstatus/' + id, status).pipe(rxjsmap(result => result));
  }

  deleteMultipleSuppliers(ids: any) {
    return this.http
      .put(environment.BASE_URL + '/suppliers', ids).pipe(rxjsmap(result => result));
  }

  checkSupplierName(name: any) {
    return this.http
      .get(environment.BASE_URL + '/checkSupplierName/' + name).pipe(rxjsmap(result => result));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
